import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/react-editor';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'tui-color-picker/dist/tui-color-picker.css';
import { root_url } from '../setting';
import { getBearerString } from '../utils/Auth';
// Editor.defineExtension('myExt', (instance) => {
//   instance.setHTML('<div>asdf</div>');
// });

const toTwo = (str) => {
  str = String(str);
  if (str.length === 1) {
    str = `0${str}`;
  }
  return str;
};
const makeDateForm = (tmpDate) => {
  return `${tmpDate.getFullYear()}-${toTwo(tmpDate.getMonth() + 1)}-${toTwo(
    tmpDate.getDate()
  )} ${toTwo(tmpDate.getHours())}:${toTwo(tmpDate.getMinutes())}:${toTwo(tmpDate.getSeconds())}`;
};
const AdminNoticeForm = ({ history, method = 'post', dataObject, postNoForPut }) => {
  console.log('method:' + method);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const editorRef = useRef();
  const [isPopup, setIsPopup] = useState(false);
  useEffect(() => {
    if (method === 'put') {
      if (dataObject.openTime || dataObject.closeTime) {
        setIsPopup(true);
      }
    }
  }, []);
  const onSubmit = (data) => {
    //작성완료시, 제목과 공지시간에 대한 데이터, TUI editor의 정보를 가져온다.
    //새 글, 수정 상황에 따라 post, put으로 전달한다.
    //startDate,Time은 없으면 빈 문자열로 넘겨준다.
    const { title, startDate, endDate, startTime, endTime, size } = data;
    const editorInstance = editorRef.current.getInstance();
    const contentHTML = editorInstance.getHTML();
    console.log(contentHTML);
    console.log(startDate);
    console.log(title, typeof startDate, startTime, endDate, endTime);
    let openTime = null,
      closeTime = null;
    let startDateObj = null,
      endDateObj = null;
    if (!(startDate === '' || startDate === undefined)) {
      const tmpDate = new Date(`${startDate} ${startTime}`);
      openTime = makeDateForm(tmpDate);
      startDateObj = tmpDate;
    }
    if (!(endDate === '' || endDate === undefined)) {
      const tmpDate = new Date(`${endDate} ${endTime}`);
      closeTime = makeDateForm(tmpDate);
      endDateObj = tmpDate;
    }

    if (startDateObj !== null && endDateObj !== null) {
      if (startDateObj > endDateObj) {
        alert('팝업시작일은 종료일보다 앞서야합니다');
        return;
      }
    } else if (isPopup) {
      // 팝업 게시물인데, 시작일과 종료일이 입력되지 않은 경우
      alert('팝업시작일과 종료일을 입력해주세요.');
      return;
    }

    let accessToken = getBearerString();
    axios({
      method,
      url: `${root_url}/api/admin/notice`,
      data: {
        title,
        openTime,
        closeTime,
        postNo: postNoForPut ? postNoForPut : null,
        mimeType: 'text/html',
        size,
        content: contentHTML,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: accessToken,
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          //data 올바르게 전송되면 postNo를 받아와야함
          const { data } = res;
          history.push(`/admin/board/notice/${data.postNo}`);
          window.location.href = window.location.href;
          return;
        }
      })
      .catch((e) => {
        console.log(data);
        console.log(e);
        if (e?.response?.status === 403) {
          alert('권한이 존재하지 않습니다.');
          localStorage.setItem('accessToken', '');
          window.location.href = '/admin/login';
        }
        if (e.response === undefined) {
          alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
        } else {
          alert(e.response.data.errorMessage);
        }
      });
  };
  return (
    <Container>
      <h1 className="mt-4 mb-4">공지사항 작성</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="p-2">
          <Col>
            <div className="form-floating">
              <input
                className="form-control"
                placeholder=" " //이래야 form-floating animation 적용됨
                type="text"
                defaultValue={method === 'put' ? dataObject.title : ''}
                {...register('title', { required: true })}
              ></input>
              <label>제목</label>
            </div>
            {errors.title && (
              <p style={{ fontSize: '0.8rem', color: 'red' }}>제목을 입력해주세요</p>
            )}
          </Col>
        </Row>
        <Row className="p-2">
          <Col>
            <input
              type="checkbox"
              id="check"
              checked={isPopup}
              onChange={() => {
                if (isPopup) {
                  setIsPopup(false);
                } else {
                  setIsPopup(true);
                }
              }}
            />
            <label htmlFor="check" style={{ lineHeight: '2rem' }}>
              팝업
            </label>
          </Col>
          <Col xs={11}>
            {isPopup && (
              <div className="row">
                <Col>
                  <span>팝업 시작일 </span>
                  <input
                    type="date"
                    className="me-3"
                    defaultValue={
                      method === 'put' &&
                      (dataObject.openTime ? dataObject.openTime.split(' ')[0] : '')
                    }
                    {...register('startDate')}
                  />
                  <input
                    type="time"
                    defaultValue={
                      method === 'put' &&
                      (dataObject.openTime ? dataObject.openTime.split(' ')[1] : '00:00')
                    }
                    {...register('startTime')}
                  />
                </Col>
                <Col>
                  <span>팝업 종료일 </span>
                  <input
                    type="date"
                    {...register('endDate')}
                    className="me-3"
                    defaultValue={
                      method === 'put' &&
                      (dataObject.closeTime ? dataObject.closeTime.split(' ')[0] : '')
                    }
                  />
                  <input
                    type="time"
                    defaultValue={
                      method === 'put' &&
                      (dataObject.closeTime ? dataObject.closeTime.split(' ')[1] : '00:00')
                    }
                    {...register('endTime')}
                  />
                </Col>
              </div>
            )}
          </Col>
        </Row>
        {isPopup && (
          <Row className="p-2">
            <Col xs={6}>
              <span style={{ lineHeight: '2rem', paddingRight: '2rem' }}>팝업 크기</span>
              <select
                defaultValue={method === 'put' ? dataObject.size : 'md'}
                {...register('size')}
              >
                <option value="xl">xl</option>
                <option value="lg">lg</option>
                <option value="md">md</option>
                <option value="sm">sm</option>
              </select>
            </Col>
          </Row>
        )}
        <div className="p-2">
          {method === 'put' ? (
            //공지사항 수정할때
            <Editor
              usageStatistics={false}
              initialEditType="wysiwyg"
              ref={editorRef}
              plugins={[colorSyntax]}
              initialValue={dataObject.content}
              // exts={['myExt']}
            />
          ) : (
            //새 글 작성할때
            <Editor
              usageStatistics={false}
              initialEditType="wysiwyg"
              ref={editorRef}
              plugins={[colorSyntax]}
              // exts={['myExt']}
            />
          )}
        </div>
        <button onClick={handleSubmit} className="bg-custom-color button-in-class text-white">
          작성 완료하기
        </button>
      </form>
    </Container>
  );
};
export default AdminNoticeForm;
